import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/shared/item_box';


function RemumeScreen() {
    return (
        <Fragment>
            <Head titulo="Concessão CEDAE - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1}>
                    <Col>
                        <ItemBox
                            titulo={"Relatórios de Receita da Concessão"}
                            texto={<Fragment>Relatórios de transparência que envolvem receitas e despesas da concesão da CEDAE no Município de Macuco<br /><br /></Fragment>}
                            link={"arquivos/docs/concessao-cedae-receitas.pdf"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"AGENERSA"}
                            texto={<Fragment>Agência Reguladora de Energia e Saneamento Básico do Estado do Rio de Janeiro<br /><br /></Fragment>}
                            link={"https://www.agenersa.rj.gov.br/"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RemumeScreen;